module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crtc1",
    attrs: {
      "id": "d7e255"
    }
  }, [_c('span', [_vm._v("Copyright © 2010 by Lane Morgan. All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "crtc",
    attrs: {
      "id": "d7e335"
    }
  }, [_c('span', [_vm._v("Cover and interior design by Diane McIntosh."), _c('br'), _vm._v("\n  Cover and interior illustrations by Celeste June Henriquez, Portland, ME.")])]), _vm._v(" "), _c('p', {
    staticClass: "crtc2",
    attrs: {
      "id": "d7e455"
    }
  }, [_c('span', [_vm._v("Printed in Canada. First printing October 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "crtc",
    attrs: {
      "id": "d7e505"
    }
  }, [_c('span', [_vm._v("Inquiries regarding requests to reprint all or part of "), _c('i', [_vm._v("Winter Harvest Cookbook")]), _c('br'), _vm._v("\n  should be addressed to New Society Publishers at the address below.")])]), _vm._v(" "), _c('p', {
    staticClass: "crtc",
    attrs: {
      "id": "d7e635"
    }
  }, [_c('span', [_vm._v("To order directly from the publishers, please call toll-free"), _c('br'), _vm._v("\n  (North America) 1-800-567-6772, or order online at"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.newsociety.com",
      "id": "d14e94",
      "target": "_blank"
    }
  }, [_vm._v("www.newsociety.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "crtc2",
    attrs: {
      "id": "d7e745"
    }
  }, [_c('span', [_vm._v("Any other inquiries can be directed by mail to:"), _c('br'), _vm._v("\n  New Society Publishers"), _c('br'), _vm._v("\n  P.O. Box 189, Gabriola Island, BC V0R 1X0, Canada"), _c('br'), _vm._v("\n  (250) 247-9737")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e905"
    }
  }, [_c('span', [_vm._v("New Society Publishers’ mission is to publish books that contribute in fundamental ways to building an ecologically sustainable and just society, and to do so with the least possible impact on the environment, in a manner that models this vision. We are committed to doing this not just through education, but through action. Our printed, bound books are printed on Forest Stewardship Council-certified acid-free paper that is "), _c('b', [_vm._v("100% post-consumer recycled")]), _vm._v(" (100% old growth forest-free), processed chlorine free, and printed with vegetable-based, low-VOC inks, with covers produced using FSC-certified stock. New Society also works to reduce its carbon footprint, and purchases carbon offsets based on an annual audit to ensure a carbon neutral footprint. For further information, or to browse our full list of books and purchase securely, visit our website at: "), _c('a', {
    attrs: {
      "href": "http://www.newsociety.com",
      "id": "d14e104",
      "target": "_blank"
    }
  }, [_vm._v("www.newsociety.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1345"
    }
  }, [_c('span', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IBRARY AND")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RCHIVES")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANADA")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ATALOGUING IN")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("UBLICATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1575"
    }
  }, [_c('span', [_vm._v("Morgan, Lane, 1949-"), _c('br'), _vm._v("\n  Winter harvest cookbook : how to select and prepare fresh seasonal produce all winter long / Lane Morgan. — Rev. and updated 20th anniversary ed.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1735"
    }
  }, [_c('span', [_vm._v("Includes bibliographical references"), _c('br'), _vm._v("\n  ISBN 978-0-86571-679-7      eISBN: 978-1-55092-458-9")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1845"
    }
  }, [_c('span', [_vm._v("1. Cooking (Vegetables).  I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1895"
    }
  }, [_c('span', [_vm._v("TX801.M68 2010           641.6'5           C2010-904787-7")])]), _vm._v(" "), _c('p', {
    staticClass: "serl"
  }, [_c('span', [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "2010-11-08T18-23-50-706_9781550924589_0005_002",
      "id": "d14e135",
      "src": "Images/2010-11-08T18-23-50-706_9781550924589_0005_002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "crt1",
    attrs: {
      "id": "d7e18995"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.newsociety.com",
      "target": "_blank"
    }
  }, [_vm._v("www.newsociety.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-629ba54a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c3_r1.vue
// module id = 66
// module chunks = 0